import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { StoreHubProps } from './get-static-props'
import styles from './landing-feature-store-hub.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import { StoreHubIntro } from './components/hub-intro'
import { Head, renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { StoreHubList } from './components/store-hub-list'
import { Cta } from './components/cta'
import { HowStoresWork } from './components/how-stores-work'

export function LandingFeatureStoreHub({
  story,
  preview,
  generatedAt,
}: StoreHubProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })
  const SEO = content?.SEO?.[0]
  const { intro, findStore, howStoresWork, cta } = content

  const introTitle = intro[0].title
  const introBody = renderWithResolver(intro[0].body)

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="cinch store | Buy a car in person"
        fallbackDescription="Drop into a cinch store to buy a car, faff-free and in person. See, touch and test-drive your next car at your closest cinch store."
      />
      <article>
        <Wrapper className={{ container: styles.storeHubIntroWrapper }} isSlim>
          <StoreHubIntro title={introTitle} body={introBody} />
        </Wrapper>
        <Wrapper
          className={{ container: styles.sectionWrapper }}
          isSlim
          backgroundColor="#F2F5FF"
        >
          <StoreHubList findStoreList={findStore[0]} />
        </Wrapper>
        <Wrapper isSlim className={{ container: styles.howStoresWorkWrapper }}>
          <HowStoresWork howStoresWork={howStoresWork} />
        </Wrapper>
        <Wrapper isSlim backgroundColor="#ECF5F9">
          <Cta cta={cta[0]} />
        </Wrapper>
      </article>
    </>
  )
}

export default LandingFeatureStoreHub
